var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';

import FileImage from './FileImage';

function FileGridItem(props) {
    var file = props.file,
        actionIcon = props.actionIcon,
        onFileClick = props.onFileClick,
        onActionClick = props.onActionClick,
        index = props.index,
        rest = _objectWithoutProperties(props, ['file', 'actionIcon', 'onFileClick', 'onActionClick', 'index']);

    var handleActionClick = function handleActionClick() {
        onActionClick && onActionClick(file, index);
    };

    var handleDownload = function handleDownload() {
        onFileClick && onFileClick(file);
    };

    return React.createElement(
        GridListTile,
        _extends({}, rest, {
            style: _extends({}, rest.style, {
                width: 'auto',
                border: '1px solid rgba(0, 0, 0, 0.4)',
                padding: 0,
                margin: '2.5px'
            })
        }),
        React.createElement(FileImage, {
            src: file.preview ? file.preview : file.link,
            alt: file.name,
            onClick: handleDownload,
            style: {
                height: '100%',
                cursor: 'pointer'
            }
        }),
        React.createElement(GridListTileBar, {
            title: file.name,
            subtitle: React.createElement(
                'span',
                null,
                file.length + ' bytes'
            ),
            actionIcon: React.createElement(
                IconButton,
                { onClick: handleActionClick },
                actionIcon
            )
        })
    );
}

FileGridItem.muiName = 'GridListTile';

FileGridItem.defaultProps = {
    style: {}
};

FileGridItem.propTypes = process.env.NODE_ENV !== "production" ? {
    style: PropTypes.object,
    onFileClick: PropTypes.func,
    onActionClick: PropTypes.func,
    actionIcon: PropTypes.node
} : {};

export default FileGridItem;